module.exports = __webpack_public_path__ + "img/Testaments_3.png";